// Secret 13 - Brand Language System
// Central source for all brand copy and messaging

export const BRAND = {
  name: "Secret 13",
  tagline: "A Collection of Secrets",
  values: "Private. Curated. Limited.",
  
  // Core brand story
  story: {
    headline: "Why Secret 13?",
    opening: "Some things are better kept between those who understand.",
    paragraphs: [
      "Secret 13 began with a simple belief: the finest experiences are personal ones. Not broadcast. Not shared with everyone. Just yours.",
      "We call them Secrets because that's what they are—private moments, crafted for those who appreciate subtlety over spectacle.",
      "The number 13 represents the unexpected. In a world of safe choices, we chose the number others avoid. Because the best things in life often come from looking where others don't.",
      "Each Secret in our collection is designed to express a different mood, moment, or ritual. Not to overwhelm, but to complement. Not to escape, but to arrive."
    ],
    closing: "This is not a brand for everyone. And that's exactly the point."
  },
  
  // Philosophy pillars
  philosophy: [
    {
      title: "Private",
      description: "What happens with a Secret stays between you and the moment. We believe in discretion, not display."
    },
    {
      title: "Curated",
      description: "Every Secret is chosen, not collected. We release only what meets our standard—nothing more."
    },
    {
      title: "Refined",
      description: "Quality isn't a feature. It's the foundation. Each Secret undergoes rigorous testing and selection."
    },
    {
      title: "Personal",
      description: "Different moments call for different Secrets. We craft for moods, not masses."
    }
  ],
  
  // Trust & quality messaging
  trust: {
    headline: "Quality Without Compromise",
    intro: "Every Secret meets the highest standards before it reaches you.",
    commitments: [
      {
        title: "Lab Tested",
        description: "Each batch is independently tested for purity, potency, and safety. We share the results."
      },
      {
        title: "Premium Grade",
        description: "We source only top-shelf flower. If it doesn't meet our standard, it doesn't carry our name."
      },
      {
        title: "Discreet Delivery",
        description: "Plain packaging. No logos. No indication of contents. Your privacy is paramount."
      },
      {
        title: "Member Privacy",
        description: "We never share member information. Your relationship with Secret 13 remains yours alone."
      }
    ]
  },
  
  // FAQ content
  faq: [
    {
      question: "What is Secret 13?",
      answer: "Secret 13 is a private, members-only collection of premium cannabis flower. Each release—called a Secret—is crafted to deliver a specific experience, from deep calm to sharp focus."
    },
    {
      question: "Why 'Secrets'?",
      answer: "We believe the best experiences are personal. A Secret isn't meant to be shared with everyone—it's meant for those who understand and appreciate it."
    },
    {
      question: "How do I become a member?",
      answer: "Access is granted to verified adults (21+) who complete our brief application. Once approved, you gain instant access to the full collection."
    },
    {
      question: "Is this legal?",
      answer: "Yes. Secret 13 operates in full compliance with state regulations. We deliver only to addresses within legal jurisdictions and verify age for every order."
    },
    {
      question: "How is it delivered?",
      answer: "All orders ship in plain, unmarked packaging with no indication of contents. Delivery is tracked and requires adult signature."
    },
    {
      question: "What makes Secret 13 different?",
      answer: "We're not trying to be everything to everyone. We focus on quality over quantity, releasing only what meets our exacting standards. Each Secret is designed for a specific moment or mood."
    },
    {
      question: "Can I return a Secret?",
      answer: "Due to the nature of our products, we cannot accept returns. However, if there's ever an issue with quality, contact our concierge team and we'll make it right."
    },
    {
      question: "How do I contact you?",
      answer: "Members can reach our concierge team through the Contact page. We respond within 24 hours, often sooner."
    }
  ],
  
  // Concierge messaging
  concierge: {
    headline: "Member Concierge",
    intro: "Questions, requests, or feedback—we're here for our members.",
    availability: "Available Monday through Friday, 10am to 6pm PST",
    responseTime: "We respond within 24 hours",
    note: "For urgent matters, please indicate in your message."
  },
  
  // Product category descriptions
  categories: {
    night: {
      name: "Night Secrets",
      description: "For the late hours. When the world quiets and you seek stillness."
    },
    focus: {
      name: "Focus Secrets", 
      description: "For clarity and presence. When your mind needs to be exactly where you are."
    },
    calm: {
      name: "Calm Secrets",
      description: "For unwinding. When the weight of the day needs somewhere to go."
    },
    signature: {
      name: "Signature Secrets",
      description: "Our most distinctive. Complex, layered, unforgettable."
    }
  },
  
  // Footer/legal
  legal: {
    copyright: "© 2025 Secret 13. All rights reserved.",
    disclaimer: "For adult use only. 21+ in legal jurisdictions.",
    membersOnly: "Members only."
  }
};

export default BRAND;
